module.exports = __webpack_public_path__ + "static/media/robin-hood-hat.6bab1449.svg";